<template>
  <div class="card-item p-3">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <h3 class="title">Rotalar </h3>
    </div>
    <div class="table-form table-responsive">
    <table class="table sailRouteTable">
      <thead>
      <tr>
        <th>Liman</th>
        <th>Varış Zamanı</th>
        <th>Kalkış Zamanı</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(route,index) in sailRouteList" v-bind:key="route.id">
        <th>
          <span v-if="!edit">{{ route.port.name }}</span>
          <a v-if="!edit" :href="basePath+'/ports/'+route.port.id" target="_blank">#{{route.port.id}}
          </a>
          <select v-if="edit" :id="'port-'+route.id" v-model="route.portId" class="my-select" name="sailRoutePort" type="text" placeholder="">
            <option v-for="port in portList" :value="port.id"> {{port.name}} </option>
          </select>
        </th>

        <th>{{ route.arrivalDate | ddMMyyyyHHmm}}<input :id="route.id" :index="index" style="width: 0px;height: 0px;opacity: 0;"></th>
        <th>{{ route.departureDate | ddMMyyyyHHmm}}</th>
      </tr>
      </tbody>
    </table>
  </div>
    <div class="section-block mb-4"></div>
  </div>
</template>

<script>

export default {
  name: "SailRouteList",
  data(){
    return{
      edit : false
    }
  },
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath;
      }
    },
    sailRouteList:{
      get(){
        if(this.$store.getters.getRouteList === null){
          return undefined;
        }
        return this.$store.getters.getRouteList.sort((a, b) => {
          let aDate = a.departureDate !== null ? a.departureDate : a.arrivalDate;
          let bDate = b.departureDate !== null ? b.departureDate : b.arrivalDate;
          return (aDate > bDate) ? 1 : -1
        })
      }
    },
    portList:{
      get(){
        return this.$store.getters.getPortList;
      }
    }
  },
  updated() {
    $('.sailRouteTable').footable();
  },
  watch:{
      edit:{
        deep:true,
        handler:function (){
          setTimeout(function () {
            $(".select-contain-select").selectpicker('refresh');
          }, 10);
        }
      }
  }
}
</script>

<style scoped>

</style>